import { render, staticRenderFns } from "./Archive.vue?vue&type=template&id=7670981f"
import script from "./Archive.vue?vue&type=script&lang=ts"
export * from "./Archive.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports